import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.supported-epm-types', {
        url: '/supported-epm-types',
        component: 'companySupportedEpmTypes',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-epm-types/list/supported-epm-types.state.js